import React, { useEffect, useState } from "react";
import UserDetailsMobile from "./UserDetailsMobile";
import { useNavigate } from "react-router-dom";
import { sampleReceived } from "redux-store/kit/kit.slice";
import { useDispatch } from "react-redux";
import { AppDispatch } from "redux-store/store";
import { getnotReceiveTests, getnotsubmittedTests } from "redux-store/lab-tests/tests.slice";

type PropsType = {
  kits: any[];
  setLoadings?: any;
  setTests: any;
};

const UserDetails = ({ kits, setLoadings, setTests }: PropsType) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1060);
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const [loading, setLoading] = useState("");

  const handleResize = () => {
    setIsMobile(window.innerWidth <= 1060);
  };

  const handleSample = (kit: any) => {
    setLoading(kit);
    dispatch(sampleReceived(kit)).then(() => {
      setLoading("");
      setLoadings(true);
      dispatch(getnotReceiveTests()).then((res) => {
        const data = res.payload.labResults;
        setTests(data);
        setLoadings(false);
      });
    });
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <>
      {isMobile ? (
        kits.length > 0 ? (
          kits.map((kit, index) => (
            <UserDetailsMobile setTests={setTests} setLoadings={setLoading} key={index} kit={kit} />
          ))
        ) : (
          <p className="tw-text-center tw-py-4">No records found</p>
        )
      ) : (
        <div className="tw-hidden lg:tw-w-[90%] lg:tw-mx-auto lg:tw-flex lg:tw-flex-col">
          <div className="tw-w-full tw-py-3 tw-bg-[#FFFFFF] tw-rounded-xl tw-shadow-3xl">
            <div className="tw-w-[90%] tw-mx-auto">
              <table className="tw-w-full">
                <thead>
                  <tr className="tw-text-darkPurple tw-text-xl tw-font-bold">
                    <th className="tw-text-left tw-pb-2 tw-w-[25%]">User Name</th>

                    <th className="tw-text-left tw-pb-2 tw-w-[25%]">Pet Name</th>
                    <th className="tw-text-left tw-pb-2 tw-w-[25%]">Activation Code</th>
                    <th className="tw-text-right tw-pb-2 tw-w-[25%]">Actions</th>
                  </tr>
                  <tr>
                    <td colSpan={4} className="tw-pb-2">
                      <hr className="border-[1px] border-solid border-black" />
                    </td>
                  </tr>
                </thead>
                <tbody>
                  {kits.length > 0 ? (
                    kits.map((kit, index) => (
                      <tr key={index}>
                        <td className="tw-border-b tw-border-black">{kit.userId ? kit.userId.fullName : "Unknown"}</td>

                        <td className="tw-py-2 tw-border-b tw-border-black">{kit?.petId?.petName || "None"}</td>
                        <td className="tw-py-2 tw-border-b tw-border-black">{kit.kitId ? kit.kitId.code : "None"}</td>
                        <td className="tw-py-2 tw-text-right tw-border-b tw-border-black">
                          <div className="tw-flex tw-items-center tw-justify-end tw-gap-3">
                            <button
                              className="tw-bg-[#FF7B6D] tw-py-2 tw-px-8 tw-rounded-md tw-text-lg tw-text-[#FFFFFF]"
                              onClick={() => navigate("/admin/lab-result")}
                            >
                              View
                            </button>
                            <button
                              className={`tw-min-w-fit tw-text-lg tw-font-bold tw-py-2 tw-px-6 tw-rounded-lg tw-border-2 ${
                                kit?.kitId?.recieved
                                  ? "tw-text-gray-400 tw-border-gray-400"
                                  : "tw-text-black tw-border-black"
                              }`}
                              onClick={() => handleSample(kit)}
                              disabled={kit?.kitId?.recieved || loading === kit}
                            >
                              {loading === kit ? "updating..." : "Sample Received"}
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={4} className="tw-py-4 tw-text-center">
                        No records found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default UserDetails;
